import { DataStore } from "@/datastore";
import { BehaviorProvider } from "./behavior";
import { EcommerceProvider } from "./ecomm";
import { getBehaviorAndEcommInferences } from "./get-inferences";
import { getPersonaInferences } from "./get-inferences";
import { PersonaProvider } from "./persona";
import { CartObserverProvider } from "../cart";
import { calculateIntentDiversity } from "./utils/calculate-intent-diversity";
import { InferenceSetup } from "@/inference/setup";

export const InferenceEngineProvider = {
  init() {
    PersonaProvider.init();
    console.log("INITIALIZING PERSONA PROVIDER");
    BehaviorProvider.init();
    EcommerceProvider.init();
  },

  infer() {
    setTimeout(() => {
      InferenceEngineProvider.personaInferences();
    }, 1_500);

    InferenceSetup.registerInterval(
      setInterval(InferenceEngineProvider.behaviorAndEcommInferences, 10_000),
    );
  },

  personaInferences() {
    const body = {
      primary: window.helium.attributes.persona.primary,
      secondary: window.helium.attributes.persona.secondary,
    };

    getPersonaInferences(body).then(
      ({ inference: final, strongestInference }) => {
        window.helium.attributes.fromPersona = {
          inference: final,
          strongestInference,
        };

        window.helium.attributes.persona.tertiary = final;
      },
    );
  },

  behaviorAndEcommInferences() {
    const others: NumericVariables = {
      avgIntentOnSections:
        Object.values(DataStore.getSectionScores()).reduce(
          (sum, score) => sum + score,
          0,
        ) /
        Object.keys(DataStore.getSectionScores()).length /
        100,
      totalCartOps: CartObserverProvider.getAllCartOperations().length,
      intentOnSingleTag:
        Math.max(...Object.values(DataStore.getCleanInference())) / 100,
      diversityOfIntentOnTags: calculateIntentDiversity(
        DataStore.getCleanInference(),
      ),
      deviceTier:
        (parseInt(window.helium.attributes.persona.primary.deviceModelTier) ||
          0) / 10,
      deviceRecency:
        (parseInt(
          window.helium.attributes.persona.primary.deviceModelRecency,
        ) || 0) / 10,
      os: window.helium.attributes?.persona?.primary?.osName || "",
      cityTier: window.helium.attributes?.persona?.secondary?.cityTier || "",
      income: window.helium.attributes?.strongestInference?.income_level || "",
      age: window.helium.attributes?.strongestInference?.age || "",
      totalAddToCarts: CartObserverProvider.getAllCartOperations().length,
      totalIntent: Object.values(DataStore.getCleanInference()).reduce(
        (sum, score) => sum + score,
        0,
      ),
    };

    const body = {
      ecomm: {
        primary: window.helium.attributes.ecommerce.primary,
        secondary: window.helium.attributes.ecommerce.secondary,
      },
      behavior: {
        secondary: window.helium.attributes.behavior.secondary,
        tertiary: window.helium.attributes.behavior.tertiary,
      },
      inferenceFromIntent: DataStore.getCleanNestedDemographicInference(),
      inferenceFromPersona: window.helium.attributes.fromPersona?.inference,
      others,
    };

    getBehaviorAndEcommInferences(body).then(
      ({ ecommerce, behavior, mergedInference, strongestInference }) => {
        window.helium.attributes.fromEcommerce = ecommerce.fromEcommerce;

        window.helium.attributes.ecommerce.secondary =
          ecommerce.secondaryAttributes;

        window.helium.attributes.fromBehavior = behavior.fromBehavior;

        window.helium.attributes.fromEverything = mergedInference;

        window.helium.attributes.strongestInference = strongestInference;

        if (window.location.search.includes("age")) {
          window.helium.attributes.strongestInference.age =
            new URL(window.location.href).searchParams.get("age") || "";
        }

        if (window.location.search.includes("gender")) {
          window.helium.attributes.strongestInference.gender =
            new URL(window.location.href).searchParams.get("gender") || "";
        }
      },
    );
  },
};

interface NumericVariables {
  avgIntentOnSections: number;
  totalCartOps: number;
  intentOnSingleTag: number;
  diversityOfIntentOnTags: number;
  deviceTier: number;
  deviceRecency: number;
  os: string;
  cityTier: string;
  income: string;
  age: string;
  totalAddToCarts: number;
  totalIntent: number;
}
